import Cookies from 'js-cookie';

export const isLoggedIn = (): boolean => {
  return Boolean(Cookies.get('token'));
};
